import { LoadableAfterPaint } from '@confluence/loadable';

export const EditorContentStateComponent = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EditorContentStateEditorContentStateComponent" */ '../src/EditorContentState/EditorContentStateComponent.tsx'
			)
		).EditorContentStateComponent,
});
